class XophHeader extends HTMLElement {
  connectedCallback() {
    this.menuButton = this.querySelector('.xoph-header__menu-button');
    this.mobileMenu = this.querySelector('.xoph-mobile-menu');

    this.onScroll = () => this.setScrolledState();
    this.onKeydown = (event) => {
      if (event.key === 'Escape' && this.classList.contains('is-menu-open')) {
        this.setMenuOpen(false);
        this.menuButton.focus();
      }
    };
    this.onMenuClick = (event) => {
      if (event.target.closest('a')) this.setMenuOpen(false);
    };
    this.onViewportChange = () => this.setMenuOpen(false);

    this.setScrolledState();
    window.addEventListener('scroll', this.onScroll, { passive: true });

    if (!this.menuButton || !this.mobileMenu) return;

    this.onMenuButtonClick = () => {
      this.setMenuOpen(!this.classList.contains('is-menu-open'));
    };
    this.menuButton.addEventListener('click', this.onMenuButtonClick);
    this.mobileMenu.addEventListener('click', this.onMenuClick);
    document.addEventListener('keydown', this.onKeydown);
    this.mobileBreakpoint = window.matchMedia('(min-width: 990px)');
    this.mobileBreakpoint.addEventListener('change', this.onViewportChange);
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    document.removeEventListener('keydown', this.onKeydown);
    this.menuButton?.removeEventListener('click', this.onMenuButtonClick);
    this.mobileMenu?.removeEventListener('click', this.onMenuClick);
    this.mobileBreakpoint?.removeEventListener('change', this.onViewportChange);
    document.body.classList.remove('xoph-menu-open');
  }

  setMenuOpen(isOpen) {
    if (!this.menuButton || !this.mobileMenu) return;
    this.classList.toggle('is-menu-open', isOpen);
    this.menuButton.setAttribute('aria-expanded', String(isOpen));
    this.menuButton.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
    this.mobileMenu.setAttribute('aria-hidden', String(!isOpen));
    document.body.classList.toggle('xoph-menu-open', isOpen);
  }

  setScrolledState() {
    this.classList.toggle('is-scrolled', window.scrollY > 0);
  }
}

if (!customElements.get('xoph-header')) {
  customElements.define('xoph-header', XophHeader);
}
